import { AUTH_ROUTES } from '../../constants/_routes'
import auth_types from '../../constants/authTypes'
import {axios} from '../../services'

// import { preferences_index } from '../preferencesActions'

const clear_state = () => {
  return {
    type: "CLEAR_APP_STATE"
  }
}

const validate_token_request = () => {
  return {
    type: auth_types.VALIDATE_TOKEN.request
  }
}

const validate_token_success = (user) => {
  return {
    type: auth_types.VALIDATE_TOKEN.success,
    payload: user
  }
}

const validate_token_failure = (messages) => {
  return {
    type: auth_types.VALIDATE_TOKEN.failure,
    payload: messages
  }
}
//
// const invalidate_user = () => {
//   return {
//     type: auth_types.VALIDATE_TOKEN.failure,
//     payload: false
//   }
// }

// const validateToken = (userdata) => {
const validateToken = () => {
  return function (dispatch ) {
    // REQUEST
    dispatch(validate_token_request())

    axios.get(AUTH_ROUTES.validate_token,
      {
        data: {},
      }
    ).then( response => {
      // SUCCESS
      if (response.data && response.data.role === 'client') {
        dispatch( validate_token_success( response ) )
      } else {
        dispatch( validate_token_failure( ["Invalid user type"] ) )
        localStorage.removeItem('userdata')
        dispatch( clear_state(  ) )
      }

      // dispatch( preferences_index() )
    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        errors = [error.response.data]
      } else {
        errors = ["User verification failed."]
      }
      // FAILURE
      dispatch( validate_token_failure( errors ) )
    })
  }

}

const invalidateUser = () => {
  // localStorage.removeItem('userdata')
  return clear_state()
}

export {
  validateToken,
  invalidateUser
}



// WEBPACK FOOTER //
// ./src/js/actions/auth/validate_token.js